/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ViResponse
 */
export interface ViResponse {
    /**
     * 
     * @type {string}
     * @memberof ViResponse
     */
    serviceAgreementId?: string;
}

/**
 * Check if a given object implements the ViResponse interface.
 */
export function instanceOfViResponse(value: object): value is ViResponse {
    return true;
}

export function ViResponseFromJSON(json: any): ViResponse {
    return ViResponseFromJSONTyped(json, false);
}

export function ViResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ViResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
    };
}

export function ViResponseToJSON(json: any): ViResponse {
    return ViResponseToJSONTyped(json, false);
}

export function ViResponseToJSONTyped(value?: ViResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'serviceAgreementId': value['serviceAgreementId'],
    };
}

